import { Link } from "react-router-dom";

const points = [
  {
    icon: "ri-stack-line",
    title: "资源丰富",
    desc: "覆盖搞笑、纪录片、音乐、影视、科技等多个分类的免费视频内容。",
  },
  {
    icon: "ri-apps-2-line",
    title: "多分类浏览",
    desc: "清晰的分类导航与筛选排序，快速定位你感兴趣的视频类型。",
  },
  {
    icon: "ri-play-circle-line",
    title: "便捷观看",
    desc: "详情页集中展示视频信息与播放入口，浏览到观看一步直达。",
  },
];

export default function AboutIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-900 mb-4">
            关于黄色免费视频
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950 leading-tight">
            一站式免费视频内容聚合平台
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            黄色免费视频聚焦免费视频资源的在线聚合与展示，面向寻找多类型、高清免费视频内容的用户。我们提供清晰的分类导航、便捷的搜索与筛选能力，以及简洁流畅的观看体验，帮助你在海量内容中快速找到想看的视频。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              了解更多
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line" />
              </span>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-semibold hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 md:gap-4">
          {points.map((p) => (
            <div
              key={p.title}
              className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200"
            >
              <span className="shrink-0 w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${p.icon} text-2xl`} />
              </span>
              <div>
                <h3 className="text-base font-semibold text-foreground-950">{p.title}</h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}